import { useCookie } from "#imports";
import { useAdminStore } from "@voix/store/adminStore";
export default (nuxtPinia) => {
  const adminStore = useAdminStore(nuxtPinia);
  const releasePreviewCookie = useCookie("voix-release-preview");
  if (releasePreviewCookie.value !== null && releasePreviewCookie.value !== void 0 && releasePreviewCookie.value !== "")
    adminStore.releaseId = releasePreviewCookie.value.toString();
};
